import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Delete',
  confirmVariant = 'danger'
}) {
  const variants = {
    danger: 'bg-red-500 hover:bg-red-600 text-white shadow-lg shadow-red-500/20',
    primary: 'bg-gradient-to-r from-accent to-orange-hover text-surface-base shadow-lg shadow-accent/20',
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="flex flex-col items-center text-center py-2">
        {/* Warning icon */}
        <div className="w-14 h-14 rounded-full bg-red-500/10 flex items-center justify-center mb-4">
          <AlertTriangle size={28} className="text-red-400" />
        </div>

        <p className="text-text-secondary text-sm mb-6 max-w-sm">{message}</p>

        <div className="flex gap-3 w-full">
          <button
            onClick={onClose}
            className="flex-1 py-3 px-5 bg-surface-hover text-text-secondary border border-border rounded-xl text-sm font-medium cursor-pointer hover:bg-surface-active hover:text-text-primary transition-all"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`flex-1 py-3 px-5 border-none rounded-xl text-sm font-semibold cursor-pointer transition-all hover:scale-[1.02] active:scale-[0.98] ${variants[confirmVariant]}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
